export default __webpack_public_path__ + "static/media/south.49bb79c6.svg";